import React, { useEffect, useState, useMemo } from "react";
import { Table, Form, Pagination } from "react-bootstrap";
import { getUserInformationService, getBondsDataService } from "../../services/BondsServices";
import { USERS_TYPES } from "../../types";
import { useSelector } from "react-redux";

const RelatedBondModal = ({ mainBondId, existingRelatedBonds, setRelatedBond, onHide }) => {
  const user = useSelector((state) => state.user);
  const [allBonds, setAllBonds] = useState([]);
  const [selectedBond, setSelectedBond] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredBond, setFilteredBond] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const paginate = pageNumber => setCurrentPage(pageNumber);

  useEffect(() => {
    fetchBondsData();
  }, []);

  useEffect(() => {
    let existingBond = [];
    let existingBond_ids = existingRelatedBonds.map(related => related.bond_issue_number);
    if (existingBond_ids && existingBond_ids.length > 0) {

      existingBond = allBonds.filter((bond) => existingBond_ids.includes(bond.bond_issue_number));
      setSelectedBond(existingBond);
    }
  }, [existingRelatedBonds, allBonds]);

  useEffect(() => {
    if (allBonds.length > 0) {
      const filtered = allBonds.filter((bond) =>
        bond.bond_issue_number.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bond.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bond.Issuer.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredBond(filtered);
    }
  }, [allBonds, searchTerm]);

  const currentItems = useMemo(() => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return filteredBond.slice(indexOfFirstItem, indexOfLastItem);
  }, [currentPage, itemsPerPage, filteredBond]);

  const handleSelectedBond = (bond) => {
    const isSelected = selectedBond.some(selected => selected.bond_issue_number === bond.bond_issue_number);
    if (isSelected) {
      setSelectedBond(selectedBond.filter(selected => selected.bond_issue_number !== bond.bond_issue_number));
    } else {
      setSelectedBond([...selectedBond, bond]);
    }
  };


  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleAddBond = () => {
    const selectedBonds = selectedBond.map(bond => ({
      bond_issue_number: bond.bond_issue_number,
      title: bond.title
    }));
    setRelatedBond(selectedBonds);
    onHide();
  };

  const fetchBondsData = async () => {
    try {

      const bondsResponse = await getBondsDataService(user.userinfo.email);

      const filteredBondsWithOutMain = bondsResponse.filter(bond => {
        return !(bond.bond_issue_number === mainBondId);
      });

      setAllBonds(filteredBondsWithOutMain);
      setFilteredBond(filteredBondsWithOutMain);
    } catch (error) {
      console.error("Error fetching Bonds:", error);
    }
  };



  return (
    <div>
      <div size="auto">
        {/* <h3>Selected {userIdentifier} User</h3> */}
        <Table responsive hover size="sm">
          <thead>
            <tr>
              <th>Title</th>
              <th>Issue/Opinion #</th>
              <th> Issuer</th>
              {/* Add more columns as needed */}
            </tr>
          </thead>
          <tbody>
            {selectedBond.length > 0 && selectedBond.map((bond, index) => (
              <tr key={bond.id}>
                <td>{bond.title}</td>
                <td>{bond.bond_issue_number}</td>
                <td>{bond.Issuer}</td>

              </tr>
            ))}
          </tbody>
        </Table>
        <h3>Bonds Table</h3>
        <div>
          <Form.Control
            type="text"
            placeholder="Search by Title, Issuer or Opinion # "
            value={searchTerm}
            onChange={handleSearch}
          />
          <br></br>
        </div>
        <div>
          <Table responsive bordered striped hover size="sm">
            <thead>
              <tr>
                <th style={{ width: "80px" }}></th>
                <th>Title</th>
                <th>Issue/Opinion #</th>
                <th> Issuer</th>
                {/* Add more columns as needed */}
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 && currentItems.map((bond, index) => (
                <tr key={bond.id}>
                  <td>
                    <input
                      type="checkbox"
                      name="selectedUser"
                      value={bond}
                      checked={selectedBond.some(selected => selected.bond_issue_number === bond.bond_issue_number)}
                      onChange={() => handleSelectedBond(bond)}
                    />
                  </td>
                  <td>{bond.title}</td>
                  <td>{bond.bond_issue_number}</td>
                  <td>{bond.Issuer}</td>
                  {/* Render additional user data */}
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="d-flex justify-content-end">
            <Pagination className="float-end">
              <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
              <Pagination.Item>
                Page {currentPage} of {Math.ceil(filteredBond.length / itemsPerPage)}
              </Pagination.Item>
              <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredBond.length / itemsPerPage)} />
            </Pagination>
          </div>
        </div>
        <div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleAddBond}
          >
            Select Related Bond
          </button>
        </div>
      </div>
    </div>
  );
};

export default RelatedBondModal;
